import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/components/AuthShell";
import { PasswordInput } from "@/components/PasswordInput";
import { ResendButton } from "@/components/auth/CheckEmail";
import { homeFor } from "@/lib/constants";

export default function Login() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [unverified, setUnverified] = useState(false);

  if (user) return <Navigate to={homeFor(user)} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setUnverified(false);
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data);
      navigate(homeFor(data));
    } catch (err) {
      setError(errMsg(err));
      setUnverified(err.response?.status === 403);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Bentornato" subtitle="Accedi per inviare e seguire le tue segnalazioni." testId="login-page">
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required className="h-12" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email-input" />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="password">Password</Label>
            <Link to="/password-dimenticata" className="text-xs font-medium text-[#0F2D5E] hover:underline" data-testid="forgot-password-link">Password dimenticata?</Link>
          </div>
          <PasswordInput id="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} testId="login-password-input" />
        </div>
        {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="login-error">{error}</p>}
        {unverified && <ResendButton email={form.email} className="w-full" />}
        <Button type="submit" disabled={loading} className="h-12 w-full rounded-full bg-[#0F2D5E] text-base hover:bg-[#0B2250]" data-testid="login-submit-btn">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Accedi
        </Button>
      </form>
      <p className="mt-6 text-center text-sm text-[#495850]">
        Non hai un account? <Link to="/registrati" className="font-semibold text-[#0F2D5E] hover:underline" data-testid="go-register-link">Registrati</Link>
      </p>
    </AuthShell>
  );
}
